import BaseClass from "../../libs/base/BaseClass";

export default class CheckBoxLimitClass extends BaseClass{
    constructor(_target,_limit){
        super();
        this.name = "CheckBoxLimitClass";

        this.target = _target;
        this.limit = _limit;
    }

    onCreate() {
        this.items = $("input[type=checkbox]",this.target);

        $(".css_checkbox",this.target).on("click",this.onClick.bind(this));
        //console.log(this.name,"onCreate");
    }

    onClick(e){
        e.preventDefault();

        let count = 0;
        this.items.each(function(){
            if($(this).prop("checked")){
                count++;
            }
        });

        let t = $("input",$(e.currentTarget));
        const flag = !t.prop("checked");
        if(!flag) count--;

        if(count >= this.limit) return;
        t.prop("checked",flag);
    }

}